/**
 * Darken a hex color by multiplying each RGB channel by a factor.
 * Matches the mobile app's algorithm (0.78 = 22% darker).
 */
export function darkenColor(hex, factor = 0.78) {
  const clean = hex.replace('#', '');
  const r = Math.max(0, Math.round(parseInt(clean.substring(0, 2), 16) * factor));
  const g = Math.max(0, Math.round(parseInt(clean.substring(2, 4), 16) * factor));
  const b = Math.max(0, Math.round(parseInt(clean.substring(4, 6), 16) * factor));
  return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
}
